export default __webpack_public_path__ + "static/about3-ef32a4a1bed11f5db90fd684362e08a8.jpeg";